import { useAppSelector } from '@hooks/redux-custom';
import { useEffect, useState, useCallback } from 'react';

export const useCustomer = () => {
  const [isCustomerHaveAddress, setCustomerHavaAddress] = useState<boolean>();

  const { selectedCustomer: customer, customersAttributes: customerAttributes } = useAppSelector((state) => state.customer.value);

  useEffect(() => {
    setCustomerHavaAddress(customer?.address_count !== undefined && customer?.address_count > 0);
  }, [customer]);

  const getAttribute = useCallback(
    (attributeName: string) => {
      const selectedAttributeId = customerAttributes?.find((attr: { name: string }) => attr.name === attributeName)?.id;

      return customer
        ? customer.attributes.find((attr: { attribute_id: string | number }) => attr.attribute_id === selectedAttributeId)?.attribute_value
        : undefined;
    },
    [customer, customerAttributes],
  );

  const isIDVerified = getAttribute('IDVerified');
  const isPhoneVerified = getAttribute('phonenumberverifieddate');
  const iDVerifiedDate = getAttribute('IDVerifiedOn');

  return { customer, customerAttributes, hasAddresses: isCustomerHaveAddress, getAttribute, isIDVerified, isPhoneVerified, iDVerifiedDate };
};
